import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";

const targetArea = document.querySelector(".js-topScrollArea");
const targetNav = document.querySelector(".js-scrollArea-nav");
const targetAreaHeight = targetArea.clientHeight;
const targetNavHeight = targetNav.clientHeight;

var controller = new ScrollMagic.Controller();

var scrollVolume = TweenMax.to(targetNav, 1, {
  y: targetAreaHeight - 350 + "px",
  force3D: true,
  ease: Linear.easeNone,
});

var main_scroller = new ScrollMagic.Scene({
  triggerElement: targetArea,
  triggerHook: "onLeave",
  offset: 0,
  duration: targetAreaHeight - 350,
})
  .setTween(scrollVolume)
  // .addIndicators()
  .addTo(controller);

  main_scroller.on("enter", () => {
    $(".js-scrollArea-nav").addClass("is-nav-active");
  });
  main_scroller.on("leave", () => {
    $(".js-scrollArea-nav").removeClass("is-nav-active");
  });

window.onscroll = function () {
  scrollToggleClass("#link-topics", "js-area-active", "-area01");
  scrollToggleClass("#link-article", "js-area-active", "-area02");
  scrollToggleClass("#link-liveCamera", "js-area-active", "-area03");
  scrollToggleClass("#link-graph", "js-area-active", "-area04");
};

function scrollToggleClass(rangeTarget, classname, classname2) {
  if ($(rangeTarget).length) {
    
    let result = rangeTarget;
    let nav = ".top-scrollArea-nav-list__item";

    let scroll = $(window).scrollTop() + 200;
    let startPos = $(rangeTarget).offset().top;

    let startPosOut = $(".js-topScrollArea").offset().top;
    let endPosOut = $("#link-graph").offset().top;
    let endPos = 0;
    
    endPos = startPos + $(rangeTarget).outerHeight();



    if (scroll > startPos && scroll < endPos) {
      $(rangeTarget).addClass(classname);
      $(nav + "." + classname2).addClass(classname);
    } else {
      $(rangeTarget).removeClass(classname);
      $(nav + "." + classname2).removeClass(classname);
    }
  }
}

$(".top-scrollArea-nav-list__item a").click(function() {
  setTimeout(() => {
    $(".top-scrollArea-nav-list__item").removeClass("js-area-active");
    $(this).parent().addClass("js-area-active");
  }, 100);
});